<template>
  <div :class="[!loaded ? 'block-spinner_page' : '']">
    <div class="overlay bg-reg_black_90 z-90 fixed top-0 left-0 right-0 bottom-0 transition-none"></div>

    <div class="fixed z-100 top-28 left-0 right-0 mx-auto flex justify-center items-center"  >
      <div class="modal-block w-reg_630 rounded bg-reg_white" v-if="loaded">
        <div class="modal-block_header relative p-reg_24" :class="[!loadedPdf ? 'block-spinner_page' : '']">
          <h2 class="modal-block_title text-lg_reg text-reg_black font-semibold">Задача на сборку</h2>

          <p class="mt-reg_4 text-sm_reg text-reg_black_75">
            <span>Задача на сборку №{{task['id']}}</span>
            <span class="px-reg_5">⁄</span>
            <span>Дата: {{task['date']}}</span>
          </p>

          <button class="btn_close absolute flex items-center justify-center right-0 top-0 rounded-full w-reg_32 h-reg_32 mr-reg_12 mt-reg_12"  @click="hidePopup">
            <svg-icon name="icon__close" class="icon__close w-reg_18 h-reg_18 fill-reg_black_75"/>
          </button>

          <div class="flex flex-row space-x-[12px] mt-reg_12"  v-if="!task['status']['is_cancel']">
            <div class="grow relative">

              <div v-if="!task['employee']['id'] && task['status']['is_finish']" class="block-pink flex flex-row items-center rounded border border-reg_red_25 bg-reg_red_10 py-reg_10 px-reg_15">
                <svg-icon name="icon__alert-circle" class="icon__alert-circle w-reg_18 h-reg_18 fill-reg_red" />
                <p class="pl-reg_10 text-sm_m_reg text-reg_black">Задача уже выполнена, проставить комплектовщика нельзя.</p>
              </div>
              <div v-else-if="!task['employee']['id']" class="block-pink flex flex-row items-center rounded border border-reg_red_25 bg-reg_red_10 py-reg_10 px-reg_15">
                <svg-icon name="icon__alert-circle" class="icon__alert-circle w-reg_18 h-reg_18 fill-reg_red" />
                <p class="pl-reg_10 text-sm_m_reg text-reg_black">Выберите сотрудника для отображения товаров</p>
              </div>
              <div v-else>
                <p class="text-sm_reg text-reg_black">Комплектовщик:</p>
                <p class="text-sm_reg text-reg_black"><b>{{task['employee']['fio']}}</b></p>
              </div>

            </div>

          </div>

          <div class="flex flex-row space-x-[12px] mt-reg_12"  v-if="!task['status']['is_cancel']">
            <div class="" v-if="task['employee']['id']">

              <button type="button" @click="pdf();" class="font-medium text-reg_blue text-sm_reg mr-reg_12">
                <svg-icon name="icon__printer" class="icon__printer inline-flex w-reg_16 h-reg_16 mr-reg_8 fill-reg_black opacity-50" />
                Распечатать без картинок
              </button>

              <button type="button" @click="pdf(true);" class="font-medium text-reg_blue text-sm_reg">
                <svg-icon name="icon__printer" class="icon__printer inline-flex w-reg_16 h-reg_16 mr-reg_8 fill-reg_black opacity-50" />
                Распечатать с картинками
              </button>
            </div>
          </div>

          <div class="block-pink flex flex-row items-center mt-reg_12 rounded border border-reg_red_25 bg-reg_red_10 py-reg_10 px-reg_15" v-if="task['status']['is_cancel']">
            <svg-icon class="icon__alert-circle w-reg_18 h-reg_18 fill-reg_red" name="icon__alert-circle" />
            <p class="pl-reg_10 text-sm_m_reg text-reg_black">Задача отменена.</p>
          </div>

          <div class="modal-block_body mt-reg_12 border-t border-reg_gray_25"  style="max-height: 50vh;overflow-y: scroll;">

            <div class="mt-reg_8" v-if="task['employee']['id'] || task['status']['is_cancel'] || task['status']['is_finish']">
              <div v-for="(product, key) in task['products']" v-bind:key="key" class="flex flex-row space-x-[24px] py-reg_10 px-reg_8" :class="key>=1 ? 'border-t border-reg_gray_25' : ''">

                <div class="flex-none image-block-collect w-reg_90 h-reg_110">
                  <img :src="product['picture_src']" />
                </div>
                <div class="">

                  <p class="text-sm_reg text-reg_black font-medium">{{product['name']}}</p>
                  <p class="mt-reg_10 text-sm_reg text-reg_black font-medium">Найти: {{product['quantity_plan']}} {{product['measure']}}.</p>

                  <div class="flex flex-row items-center space-x-[10px] mt-reg_24" v-if="task['status']['is_finish']">

                    <status-icon color="red" v-if="product['quantity'] === 0" />
                    <status-icon color="orange" v-else-if="product['quantity'] !== product['quantity_plan']" />
                    <status-icon color="green" v-else />

                    <p class="text-sm_m_reg text-reg_black">Результаты поиска отправлены: найдено {{product['quantity']}} из {{product['quantity_plan']}} {{product['measure']}}.</p>

                  </div>
                  <div class="my-reg_12" v-else-if="!task['status']['is_cancel']">
                    <ui-input
                        label="Найдено:"
                        class_label="text-sm_reg text-reg_black font-medium"
                        type="number"
                        :name_custom="'product_'+product['product_id']"
                        :name="product['product_id']"
                        v-model="product['quantity']"
                        :max="product['quantity_plan']"
                        min="0"
                        class_input="text-xs_l_reg text-reg_black border border-reg_gray_75 w-reg_80 rounded py-reg_8 px-reg_8"
                    />
                  </div>

                  <p class="mt-reg_10 text-xs_l_reg text-reg_black_75">Код товара: {{product['xml_code']}}</p>
                  <p class="mt-reg_2 text-xs_l_reg text-reg_black_75">Штрихкоды: {{product['barcodes']}}</p>
                  <p class="mt-reg_2 text-xs_l_reg text-reg_black_75">SISKod: {{product['sis_code']}}</p>

                </div>
              </div>

            </div>

            <div v-else>
              <div class="flex flex-row justify-between items-center py-reg_16" v-if="!task['status']['is_cancel'] && !task['status']['is_finish']" >
                <div class="flex flex-wrap items-center">
                  <button @click="selectedEmployee(item['value'])" v-for="(item, k) in this.task['employee']['list']" v-bind:key="k" :class="[task['employee']['id'] === item['value'] ? 'text-reg_white bg-reg_blue' : 'text-reg_blue bg-reg_blue_10']" class="text-sm_reg  hover:text-reg_white hover:bg-reg_blue mr-reg_8 mb-reg_12 py-reg_10 px-reg_20 rounded">
                      {{item['title']}}
                  </button>
                </div>
              </div>
            </div>

          </div>

          <hr/>

          <div class="flex flex-row space-x-[12px] mt-reg_12"  v-if="!task['status']['is_cancel'] && task['employee']['id']">
            <div v-if="!task['status']['is_cancel'] && !task['status']['is_finish']">
              <button @click="save()" :class="[!loaded_button ? 'block-spinner_page block-spinner_20 top spinner_button' : '']" type="button" class="flex flex-row bg-reg_green hover:bg-reg_green_100 rounded font-medium text-reg_white text-sm_reg py-reg_10 px-reg_40">
                <svg-icon name="icon__sim-card" class="icon__sim-card w-reg_18 h-reg_18 fill-reg_white mr-reg_8" />
                Отправить ответ
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SvgIcon from "@/components/ui/svgicon";
import StatusIcon from "@/components/ui/status-icon";
import printJS from "print-js";
import CollectB2bService from "@/common/services/collect.b2b.service";
import OrderService from "@/common/services/order.service";
import UiInput from "@/components/ui/form/elements/input.vue";
import HelperService from "@/common/services/helper.service";

export default {
  name: "collectRequestPopup",
  components: {UiInput, StatusIcon, SvgIcon},
  data () {
    return {
      loaded : true,
      loadedPdf : true,
      task : {},
      loaded_button : true
    }
  },
  created(){
    this.getCollectTask();
  },
  props: {
    id : {}
  },
  methods : {
    selectedEmployee(employeeId){
        OrderService.setCollectRequestTaskEmployee(this.id, employeeId).finally(() => {
            this.getCollectTask(true);
        });
    },
    async getCollectTask(reload = false) {
        if(!reload)
          this.loaded = false;
        await OrderService.getCollectRequestTaskPopupData(this.id).then((response) => {
          this.task = response['data']['task'];
        }).finally(() => {
          this.loaded = true;
        });
    },
    hidePopup(){
      this.$root.$emit("collectRequestItemHide");
      this.$root.$emit("_update_page_custom");
    },
    async pdf(withPictures = false){

      this.loadedPdf = false;
      await OrderService.collectRequestTaskPdf(this.id, withPictures)
          .then((response) => {
              printJS({printable: response.data['pdf'], type: 'pdf', base64: true});
          })
          .catch((data) => {
            this.$nextTick(() => {
              this.$root.$emit("notificationShow", {title : "Ошибка формирования pdf файла", type : "error", "text" : data.data.message.errors_format.all});
            });
          }).finally(() => {
            setTimeout(() => {
              this.loadedPdf = true;
            }, 250);
          });
    },
    async save(){

      this.loaded_button = false;

      let products = [];
      this.task.products.forEach(product => {
        products.push({id : product.id, quantity : product.quantity});
      });

      await OrderService.setCollectRequestTaskProductsQuantity(this.id, products).then((response) => {
        this.getCollectTask(false);
      }).finally(() => {
        this.loaded_button = true;
      });

    }
  }
}
</script>